import * as React from 'react'
import ProductItem from './ProductItem'
import { IProduct, IProductList } from '../models/product'
import { observer } from 'mobx-react'

declare var document: any

class ProductList extends React.Component<{ productList: IProductList }, {}> {
    handleProductClick(p: IProduct) {
        document.location = p.path
    }

    public render() {
        const { productList } = this.props
        return (
            <div>
                {productList.items.map(product => (
                    <div className="small-12 medium-6 xlarge-4 columns left" key={product.id}>
                        <ProductItem
                            product={product}
                            onClick={(p: IProduct) => {
                                this.handleProductClick(p)
                            }}
                        />
                    </div>
                ))}
            </div>
        )
    }
}

export default observer(ProductList)



// WEBPACK FOOTER //
// ./react/src/components/ProductList.tsx